import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Users, TrendingUp, TrendingDown } from 'lucide-react'
import { Skeleton } from '@/components/ui/skeleton'
import { useAllClinicsPatientFlowStats } from '@/hooks/useClinicPatientFlowStats'

export default function PeopleFlowStats() {
  const { flowStats, isLoading } = useAllClinicsPatientFlowStats()

  const todayCount = flowStats?.today || 0
  const yesterdayCount = flowStats?.yesterday || 0
  const difference = todayCount - yesterdayCount
  const percentageChange = yesterdayCount > 0 ? ((difference / yesterdayCount) * 100).toFixed(1) : 0

  if (isLoading) {
    return (
      <Card className="h-full">
        <CardHeader className="pb-3">
          <Skeleton className="h-5 w-32" />
        </CardHeader>
        <CardContent>
          <Skeleton className="h-8 w-24 mb-2" />
          <Skeleton className="h-4 w-full mb-2" />
          <Skeleton className="h-4 w-3/4" />
        </CardContent>
      </Card>
    )
  }

  return (
    <Card className="h-full bg-gradient-to-br from-green-50 to-green-100/50">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <Users className="h-4 w-4 text-green-600" />
          人流統計
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div>
            <p className="text-2xl font-bold text-green-700">{todayCount.toLocaleString()}</p>
            <p className="text-xs text-gray-600">今日總人流</p>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">昨日總人流</p>
              <p className="text-lg font-semibold">{yesterdayCount.toLocaleString()}</p>
            </div>

            <div className="flex items-center gap-1">
              {difference >= 0 ? (
                <>
                  <TrendingUp className="h-4 w-4 text-green-600" />
                  <span className="text-sm font-medium text-green-600">+{percentageChange}%</span>
                </>
              ) : (
                <>
                  <TrendingDown className="h-4 w-4 text-red-600" />
                  <span className="text-sm font-medium text-red-600">{percentageChange}%</span>
                </>
              )}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
